export default __webpack_public_path__ + "static/interactive-579099216caaf0bb64b38bb2bc123840.mp4";